import { render } from "./SurveyAreas.vue?vue&type=template&id=f7b8deba&scoped=true"
import script from "./SurveyAreas.vue?vue&type=script&lang=js"
export * from "./SurveyAreas.vue?vue&type=script&lang=js"

import "./SurveyAreas.vue?vue&type=style&index=0&id=f7b8deba&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b8deba"]])

export default __exports__